export enum Breakpoint {
  MOBILE = 'base',
  TABLET = 1,
  DESKTOP = 2,
  XLARGE = 3,
}
